<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <b-card>
      <b-row class="mb-2">
        <b-col
          cols="12"
        >
          <b-form-group>
            <label>Search String</label>
            <b-input
              v-model="tableSettings.filter"
              type="text"
              placeholder="Enter search string"
              debounce="1000"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button
            type="button"
            variant="success"
            @click="onShowAddForm"
          >
            Add User
          </b-button>
        </b-col>

      </b-row>

      <b-table
        ref="table"
        hover
        responsive
        class="mt-2"
        :per-page="tableSettings.perPage"
        :current-page="tableSettings.currentPage"
        :items="myProvider"
        :fields="tableSettings.fields"
        :sort-by.sync="tableSettings.sortBy"
        :sort-desc.sync="tableSettings.sortDesc"
        :sort-direction="tableSettings.sortDirection"
        :filter="tableSettings.filter"
        :filter-included-fields="tableSettings.filterOn"
        show-empty
      >
        <template #cell(index)="data">
          {{ tableSettings.currentPage * tableSettings.perPage - tableSettings.perPage + (data.index + 1) }}
        </template>

        <template #cell(active)="data">
          {{ data.item.active == 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell()="data">
          <div class="text-nowrap">
            {{ data.value }}
          </div>
        </template>

        <template #cell(actions)="row">
          <div class="text-nowrap">
            <b-button
              size="sm"
              @click="onShowEditForm(row.item)"
            >
              Edit
            </b-button>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableSettings.perPage"
              :options="tableSettings.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableSettings.currentPage"
            :total-rows="tableSettings.totalRows"
            :per-page="tableSettings.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-user-form"
      scrollable
      no-close-on-backdrop
      :title="modalTitle"
      @ok="onConfirmAction"
    >
      <ValidationObserver
        ref="form"
      >
        <form
          role="form"
          novalidate
        >
          <ValidationProvider
            #default="{ errors }"
            name="email"
            vid="email"
            rules="required|email|max:100"
          >
            <b-form-group>
              <label for="email">Email</label>
              <b-input
                id="email"
                v-model="user.email"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter email"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="first_name"
            vid="first_name"
            rules="required|max:50"
          >
            <b-form-group>
              <label for="first_name">First Name</label>
              <b-input
                id="first_name"
                v-model="user.first_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter  first name"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="last_name"
            vid="last_name"
            rules="required|max:50"
          >
            <b-form-group>
              <label for="last_name">Last Name</label>
              <b-input
                id="last_name"
                v-model="user.last_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter last name"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="organization"
            vid="organization"
            rules="required"
          >
            <b-form-group>
              <label for="organization">Organization</label>
              <b-form-select
                id="organization"
                v-model="user.organization"
                :options="organizations"
                type="text"
                :state="errors.length > 0 ? false : null"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    -- Please Select Organization --
                  </b-form-select-option>
                </template>
              </b-form-select>
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="password"
            vid="password"
            :rules="passwordRule"
          >
            <b-form-group>
              <label for="password">Password <span v-if="editMode">(Leave blank when not changing password)</span></label>
              <b-input
                id="password"
                v-model="user.password"
                type="password"
                :state="errors.length > 0 ? false : null"
                placeholder="enter password"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="password confirmation"
            vid="password_confirmation"
            :rules="passwordConfirmationRule"
          >
            <b-form-group>
              <label for="password_confirmation">Password Confirmation <span v-if="editMode">(Leave blank when not changing password)</span></label>
              <b-input
                id="password_confirmation"
                v-model="user.password_confirmation"
                type="password"
                :state="errors.length > 0 ? false : null"
                placeholder="enter password confirmation"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="role"
            vid="role"
            rules="required"
          >
            <b-form-group>
              <label for="role">Role</label>
              <b-form-select
                id="role"
                v-model="user.role"
                :options="roles"
                type="text"
                :state="errors.length > 0 ? false : null"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    -- Please Select Role --
                  </b-form-select-option>
                </template>
              </b-form-select>
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <div
            v-if="editMode && user.id !== 1"
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="user.active"
              name="is_active"
              value="1"
              unchecked-value="0"
              :disabled="isBusy"
            >
              Is Active?
            </b-form-checkbox>
          </div>

        </form>
      </ValidationObserver>

      <template #modal-footer="{ok, cancel}">
        <b-button
          variant="success"
          :disabled="isBusy"
          @click="ok()"
        >
          {{ editMode ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="isBusy"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>

<script>
import _ from 'lodash'
import { core } from '@/config/pluginInit'
import { AxiosError, AdminUserService, SharedListService } from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'AdminUserAccounts',

  middleware: ['auth', 'admin'],

  metaInfo () {
    return {
      title: 'User Accounts'
    }
  },

  mixins: [formatter],

  data () {
    return {
      editMode: false,
      isBusy: false,
      roles: [
        { text: 'Administrator', value: 'admin' },
        { text: 'User', value: 'user' }
      ],
      organizations: [],
      user: {
        id: '',
        active: 0,
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        organization: null,
        role: null
      },
      tableSettings: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'email', sortable: true },
          { key: 'first_name', sortable: true },
          { key: 'last_name', sortable: true },
          { key: 'organization_name', sortable: true },
          { key: 'role', sortable: true },
          { key: 'active', label: 'IS ACTIVE?' },
          { key: 'updated_at', formatter: this.dateTimeFormatter, sortable: true }
        ]
      }
    }
  },

  computed: {
    modalTitle () {
      return this.editMode ? 'Edit User' : 'Add User'
    },

    passwordRule () {
      return `${this.editMode ? '' : 'required|'}min:8|confirmed:password_confirmation`
    },

    passwordConfirmationRule () {
      return `${this.editMode ? '' : 'required'}`
    }

  },

  mounted () {
    core.index()
    this.getOrganizationListList()
  },

  methods: {
    async myProvider (ctx) {
      try {
        const { data } = await AdminUserService.get(`page=${ctx.currentPage}&per_page=${ctx.perPage}&sort=${ctx.sortBy}&sort_desc=${ctx.sortDesc}&filter_text=${ctx.filter}`)
        this.tableSettings.totalRows = data.total_rows
        return data.items
      } catch {
        return []
      }
    },

    async getOrganizationListList () {
      await SharedListService.getOrganizationList().then(({ data }) => {
        this.organizations = data.map(({ id, organization_name }) => {
          return { value: id, text: organization_name }
        })
      })
    },

    onShowAddForm () {
      this.editMode = false
      this.user.id = 0
      this.user.active = 1
      this.user.email = ''
      this.user.password = ''
      this.user.password_confirmation = ''
      this.user.first_name = ''
      this.user.last_name = ''
      this.user.organization = null
      this.user.role = null
      this.$bvModal.show('modal-user-form')
    },

    onShowEditForm (item) {
      this.editMode = true
      this.user.id = item.id
      this.user.active = item.active
      this.user.email = item.email
      this.user.password = ''
      this.user.password_confirmation = ''
      this.user.first_name = item.first_name
      this.user.last_name = item.last_name
      this.user.organization = item.organization_id
      this.user.role = item.role
      this.$bvModal.show('modal-user-form')
    },

    async onConfirmAction (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.form.validate().then(async success => {
        if (success) {
          let title = 'Do you really want to create user?'
          if (this.editMode) {
            title = 'Do you really want to save changes?'
          }
          this.$swal.fire({
            icon: 'question',
            title: title,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              if (!this.editMode) {
                return this.onFormPostSubmit()
              } else {
                return this.onFormPutSubmit()
              }
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk('Oppss! There were problem with your inputs.', {
            title: 'Validation Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger'
          })
        }
      })
    },

    async onFormPostSubmit () {
      return new Promise((resolve, reject) => {
        this.isBusy = true
        AdminUserService.post(this.user).then(({ data }) => {
          this.$bvModal.hide('modal-user-form')
          this.isBusy = false
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            this.$refs.table.refresh()
          })
        }).catch(error => {
          this.isBusy = false
          if (error instanceof AxiosError) {
            if (error.code === 422) {
              this.$refs.form.setErrors(error.message)
              this.$bvModal.msgBoxOk('Oppss! There were problem with your inputs.', {
                title: 'Validation Error',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger'
              })
              resolve(error)
            }
          }
        })
      })
    },

    async onFormPutSubmit () {
      return new Promise((resolve, reject) => {
        this.isBusy = true
        AdminUserService.put(this.user).then(({ data }) => {
          this.$bvModal.hide('modal-user-form')
          this.isBusy = false
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            const row = _.find(this.$refs.table.localItems, { id: this.user.id })
            row.active = data.user.active
            row.email = data.user.email
            row.first_name = data.user.first_name
            row.last_name = data.user.last_name
            row.organization = data.user.organization_id
            row.role = data.user.role
            row.created_at = data.user.created_at
            row.updated_at = data.user.updated_at
          })
        }).catch(error => {
          this.isBusy = false
          if (error instanceof AxiosError) {
            if (error.code === 422) {
              this.$refs.form.setErrors(error.message)
              this.$bvModal.msgBoxOk('Oppss! There were problem with your inputs.', {
                title: 'Validation Error',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger'
              })
              resolve(error)
            }
          }
        })
      })
    }
  }
}
</script>
